import type { CardProps} from '@chakra-ui/react'
import { Avatar, Card, CardBody, Heading, HStack, Stack } from '@chakra-ui/react'
import type { ResetPasswordInfo } from '../../dtos'

export const ResetPasswordUserInfo = ({ fullName, email, token, passwordRules, userId, userName, ...rest }: ResetPasswordInfo & CardProps) => {
    return <Card p={4} {...rest}>
        <CardBody p={0}>
            <HStack gap={4}>
                <Avatar name={fullName} size='md' />
                <Stack alignItems='start' gap={1}>
                    <Heading color='inherit' fontSize='xl' fontWeight='bold'>
                        {fullName}
                    </Heading>
                    <Heading color='inherit' fontSize='md' fontWeight='medium'>
                        {email}
                    </Heading>
                </Stack>
            </HStack>
        </CardBody>
    </Card>
}


